import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  MenuItem,
  Box,
} from '@mui/material';
import loaderGif from "./../Assests/loader.gif";

const ServiceLevelDialog = ({ open, handleClose, handleSave, initialData }) => {
  const initialFormData = {
    service_level: '',

  };

  const [formData, setFormData] = useState(initialFormData);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setFieldErrors({});
    setFormData(initialData || initialFormData);
  }, [initialData, open]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.service_level) errors.service_level = 'ServiceLevel  is required';
  
    setFieldErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const onSave = async() => {
    if (validateForm()) {
      setIsSaving(true);
      try{
       await handleSave(formData);
        handleClose();
      }catch(error){  
        console.error("Error saving ServiceLevel:", error);
      }finally{
        setIsSaving(false);
      }
      
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{initialData ? 'Update ServiceLevel Record' : 'Add New ServiceLevel Record'}</DialogTitle>
      {isSaving && (
        <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgcolor="rgba(255, 255, 255, 0.8)"
        zIndex={1}
      >
        <img src={loaderGif} alt="Loading..." width={50} height={50} />
      </Box>
      )}
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          name="service_level"
          label="ServiceLevel *"
          fullWidth
          variant="outlined"
          value={formData.service_level}
          onChange={handleChange}
        />
        {fieldErrors.service_level && <div style={{ color: 'red', fontSize: '0.875rem' }}>{fieldErrors.service_level}</div>}

      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onSave} color="primary" variant="contained">
          {initialData ? 'Update' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceLevelDialog;
